module.exports = __webpack_public_path__ + "img/jesolospiagge-green-beach.0358c0fc.png";